import React, { Component } from 'react';
import { Modal,Form,Input,Row,Col,InputNumber,Switch } from 'antd';
import http from '../../../axios/http';
import messager from '../../ui/messager';


const fields = [ 
{
    "text": "公司名称",
    "field": "name",
    rules: [
        { required: true, message: '公司名称不能为空!' },
        { max: 32, message: '会员名不能超过32个字符！' },
    ]
}
,{
    "text": "车费每车每天",
    "field": "unitPrice",
    number: true
}
,{
    "text": "不满5按5天算",
    "field": "gatherFive",
    radio: true
}
,{
    "text": "满5不满10按10天算",
    "field": "gatherTen",
    radio: true
}
,{
    "text": "满10不满15按15天算",
    "field": "gatherFifteen",
    radio: true
}
,{
    "text": "满15不满20按20天算",
    "field": "gatherTwenty",
    radio: true
}
,{
    "text": "满20不满25按25天算",
    "field": "gatherTwentyfive",
    radio: true
}
,{
    "text": "满25不满30按30天算",
    "field": "gatherThirty",
    radio: true
}
,{
    "text": "备注",
    "field": "remark",
    textarea: true
}];


class BatchVehicleProjectEditForm extends Component {
    state = {}
    save = () => {
        const form = this.props.form;
        form.validateFields((err, values) => {
            let url='/barrier/batchVehicleProject/save'
            if (err) {
                return;
            }
            let id = this.props.editData.id
            if (id !== undefined && id != null) {
                values["id"] = id;
                url='/barrier/batchVehicleProject/update'
            }
            let code = this.props.editData.code
            if (code !== undefined && code != null) {
                values["code"] = code;
            }
            fields.forEach((json, index) => {
                if (json["radio"] === true) {
                    values[json["field"]] = values[json["field"]] ? 1 : 0;
                }
            })
            
            http.post({
                url: url,
                data: values,
                success: (res) => {
                    this.props.successCallback(this.props.queryData);
                    this.props.onCancel();
                    messager.notify("保存成功！");
                }
            });
        });
    };

    createDom = (data) => {
        const { form, editData } = this.props;
        const { getFieldDecorator } = form;
        let dom = [];
        for (let i = 0; i < data.length; i++) {
            let item = data[i];
            let itemDom = (
                <Form.Item key={i} label={item.text + "："}>
                    {
                        getFieldDecorator(item.field, {
                            rules: item.rules,
                            initialValue: item.radio ? editData[item.field] === 1 : editData[item.field],
                            valuePropName: item.radio ? 'checked' : 'value'
                        })(
                            item.number ?
                                <InputNumber precision={1} min={0.0} max={999999999} style={{ width: '100%' }} />
                            : item.textarea ? <Input.TextArea disabled={item.disabled === true} />
                                : item.radio ?
                                <Switch checkedChildren="是" unCheckedChildren="否" />:<Input />
                        )
                    }
                </Form.Item>
            );
            dom.push(itemDom);
        }
        return dom;
    };

    create2Col = (fields) => {
        let dom = this.createDom(fields);
        let result = [];
        for (let i = 0; i < dom.length; i++) {
            let item = <Col key={i} span={11} offset={i % 2 === 0 ? 0 : 2}>{dom[i]}</Col>;
            result.push(item);
        }
        return result;
    }

    render() {
        const { visible, onCancel } = this.props;
        return (
            <Modal
                visible={visible}
                title="批量车公司编辑"
                width={500}
                okText="保存"
                cancelText="取消"
                maskClosable={false}
                onCancel={onCancel}
                onOk={this.save}
                afterClose={() => { this.props.form.resetFields() }}
            >
                <Form layout="vertical" labelCol={{ span: 8 }} wrapperCol={{ span: 16 }}>
                    <Row>{this.createDom(fields)}</Row>
                </Form>
            </Modal>
        );
    }
}

const BatchVehicleProjectEdit = Form.create()(BatchVehicleProjectEditForm);

export default BatchVehicleProjectEdit;